module.exports = __webpack_public_path__ + "static/media/2024_36.3634c4e2.jpg";